export enum StartPasswordRecoveryStepsEnum {
  TYPE_EMAIL = 1,
  SEND_EMAIL = 2,
  SENDED_EMAIL = 3,
}
